import React from 'react';
import '../../../App.css';
import Hero from '../Hero/Hero';
import Cards from "../Cards/Cards";
import AboutUs from "../AboutUs/AboutUs";
import RecentProjects from "../RecentProjects/RecentProjects";

function Home() {
    return (
        <>
            <Hero />
            <Cards />
            <AboutUs />
            <RecentProjects />
        </>
    );
}

export default Home
